import * as RadioPrimitive from "@radix-ui/react-radio-group";
import { cn } from "@reactive-resume/utils";
import React, { forwardRef } from "react";

//export const RadioGroup = RadioPrimitive.Root;
export const RadioGroup = RadioPrimitive.RadioGroup;
export const Indicator = RadioPrimitive.RadioGroupIndicator;

export const RadioItem = forwardRef<
  React.ElementRef<typeof RadioPrimitive.RadioGroupItem>,
  React.ComponentPropsWithoutRef<typeof RadioPrimitive.RadioGroupItem>
>(({ className, ...props }, ref) => (
  <RadioPrimitive.Item
    ref={ref}
    className={cn(
      "shadow-blackA4 hover:bg-violet3 size-[25px] cursor-default rounded-full bg-white shadow-[0_2px_10px] outline-none focus:shadow-[0_0_0_2px] focus:shadow-black",
      className,
    )}
    {...props}
  >
    <Indicator className="after:bg-moncvpro relative flex size-full items-center justify-center after:block after:size-[11px] after:rounded-full" />
  </RadioPrimitive.Item>
));
